import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar } from 'swiper/core';
import mainClasses from '../../../pages/Main/Main.module.scss';
import classes from './SkeletonMainCategoriesSlider.module.scss';
import Skeleton from '../Skeleton';

export default function SkeletonMainCategoriesSlider() {
  const cards = [1, 2, 3, 4, 5, 6];

  return (
    <div
      className={`${mainClasses.regularSliderBox} ${mainClasses.menuSliderBox} main-regularSliderBox main-skeleton-regularSliderBox`}
    >
      <Swiper
        modules={[Scrollbar]}
        watchOverflow
        spaceBetween={20}
        slidesPerView='auto'
        breakpoints={{
          0: {
            spaceBetween: 16,
          },
          992: {
            spaceBetween: 20,
          },
        }}
        scrollbar={{ draggable: true, dragSize: 24 }}
      >
        {cards.map((item, index) => (
          <SwiperSlide className={mainClasses.menuSlide} key={index}>
            <div className={`${mainClasses.menuItem} ${classes.menuItem}`} to={item.href ? item.href : '/'}>
              <div className={`${mainClasses.menuItemImg} ${classes.menuItemImg}`}>
                <Skeleton borderRadius='0px' width='100%' height='100%' isLight />
              </div>
              <div className={`${mainClasses.menuItemName} ${classes.menuItemName}`}>
                <Skeleton borderRadius='5px' width='68.5%' height={15} isLight={false} />
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
